import { DetailTitleComponent, CustomButton } from '@/shared/ui/components';
import classNames from 'classnames';
import { t } from 'ttag';
import { useCreateReturnShippingHeader } from './useCreateReturnShippingHeader';
import type { CreateReturnShippingHeaderProps } from './createReturnShippingHeader.types';
import './createReturnShippingHeader.scss';

const CreateReturnShippingHeader = ({
  title,
  isLoadedData,
  isDisable,
  onClickCreate,
  handleClickBack,
}: CreateReturnShippingHeaderProps) => {
  const { state } = useCreateReturnShippingHeader();

  return (
    <div
      className={classNames('create-return-shipping-header', {
        '--has-box-shadow': state.isScroll,
      })}
    >
      <DetailTitleComponent
        isLoadedData={isLoadedData}
        title={title}
        rightComponent={
          <CustomButton
            id="create-return-shipping-btn"
            onClick={onClickCreate}
            disabled={isDisable}
            type="primary"
            style="default"
            size="small"
          >
            {t`Create`}
          </CustomButton>
        }
        handleClickBack={handleClickBack}
      />
    </div>
  );
};

export default CreateReturnShippingHeader;
